import { useCallback, useEffect, useMemo, useState } from 'react';
import { IntlShape } from 'react-intl';

import { api } from '../../common-utils-services/axiosUtil';
import { configs } from '../../../constants/configs/configs';

import { IIssuer, IIssuerListResponse } from '../types/issuerList';

export const useIssuerList = (intl: IntlShape, placeHolder?: string) => {
    useEffect(() => {
        fetchIssuerList();
    }, []);
    
    const [issuerList, setIssuerList] = useState<IIssuer[]>([]);

    const fetchIssuerList = useCallback(async () => {
        const url = configs.endpoints.ISSUER_LIST;
        try {
            const response = await api.get<IIssuerListResponse>(url);
            const data = response?.data?.data?.issuers;

            if (data?.length) {
                setIssuerList(data);
            }
        } catch (error) {
            throw new Error(error);
        }
    }, []);

    const issuerDropdownOptions = useMemo(() => {
        return [
            {
                text: intl.formatMessage({ id: placeHolder ?? 'admin.issuer.placeholder' }),
                value: '',
            },
            ...issuerList.map(issuer => ({
                value: issuer.hiosIssuerId,
                text: `[${issuer.hiosIssuerId}] ${issuer.shortName}`,
            })),
        ];
    }, [issuerList]);

    return {
        issuerDropdownOptions,
    };
};
